import {useRef, useState} from "react";

export function Input({name, text, defaultVal, label, type = "text", list, extraText = ''}) {
    const [inputVal, setInputVal] = useState(defaultVal || "");

    return (
        <div className="relative flex flex-col items-start py-2 border-b border-olaf-green-500">
            {label && (
                <label htmlFor={name} className="font-semibold">
                    {label}
                </label>
            )}

            {type !== 'checkbox' &&
                <input
                    type={type}
                    name={name}
                    list={name + "-list"}
                    id={name}
                    placeholder={text}
                    className={`w-full focus:!border-0`}
                    value={inputVal}
                    onChange={(e) => setInputVal(e.target.value)}
                />
            }

            {type === 'checkbox' &&
                <div className={'flex items-center'}>
                    <input
                        checked={inputVal}
                        type={type}
                        name={name}
                        list={name + "-list"}
                        id={name}
                        placeholder={text}
                        className={`focus:!border-0 w-fit}`}
                        value={inputVal}
                        onChange={(e) => setInputVal(e.target.checked)}
                    />
                    {extraText &&
                        <label htmlFor={name} className={'ml-4'}>
                            {extraText}
                        </label>
                    }
                </div>
            }
        </div>
    );
}
